export default __webpack_public_path__ + "static/media/permeable-blog-banner.798d537f.jpg";